import type { ShopProduct } from "./types";

/**
 * Per-item intake status during the checkout-questions step.
 * - "not-required": no formId on the product — proceeds through checkout unconditionally.
 * - "pending": formId present, intake not yet attempted this checkout.
 * - "passed": intake form submitted successfully this checkout attempt.
 * - "failed": intake form submitted but rejected — item stays in the cart, excluded from the charge.
 */
export type IntakeStatus = "not-required" | "pending" | "passed" | "failed";

/** Whether a product requires an intake form before purchase — presence of formId is the sole signal. */
export const requiresIntake = (product: ShopProduct): boolean => Boolean(product.formId);

/**
 * The distinct products in the cart that require intake, in cart order — one form is presented per
 * product, not per cart line/variant. A product's form association never changes based on which
 * price variant was selected (see shopProductSchema.formId).
 */
export const getGatedMedications = (products: ShopProduct[]): ShopProduct[] => products.filter(requiresIntake);
